module.exports = __webpack_public_path__ + "static/addProduct-0ed6929084ae3a4a382ccbe8f787c295.mp3";